import React from 'react';

// Move static data outside (performance optimization)
const dateCategories = [
  {
    category: "Papers",
    dates: [
      { event: "Submissions Starts", date: "March 2, 2026" },
      {
        event: "Submission Deadline",
        oldDate: "March 31, 2026",
        newDate: "April 07, 2026",
        newDate1:"April 15, 2026",
        newDate2:"April 30, 2026"
      },
      { event: "Review Results", oldDate: "June 20, 2026", newDate: "June 23, 2026" },
      { event: "Final Camera Ready Paper Submission", oldDate: "June 20 – July 05, 2026", newDate: "June 23 – July 08, 2026" },
      { event: "Early Bird Registration", oldDate: "June 20 – July 05, 2026", newDate: "June 23 – July 08, 2026" },
      { event: "Late Registration", date: "July 09 – July 22, 2026" },
    ]
  },
  {
    category: "Challenges",
    dates: [
      { event: "Challenges Proposal Submission Starts", date: "January 7, 2026" },
      {
        event: "Challenges Proposal Submission Deadline",
        oldDate: "February 08, 2026",
        newDate: "February 15, 2026"
      },
      { event: "Notification of Accepted Challenges", date: "February 16, 2026" },
      { event: "Web Posting of Challenges", date: "February 17, 2026" },
      { event: "Opening Date for Submission to Challenges", date: "February 24, 2026" },
      { event: "Closing Date for Submission to Challenges", date: "June 05, 2026" },
      { event: "Announcement of Challenge Winners", date: "June 20, 2026" },
      { event: "Registration for Challenge Attendees", date: "June 20 – July 15, 2026" }
    ]
  },
  {
    category: "Tutorials",
    dates: [
      { event: "Tutorial Proposal Submission Starts", date: "March 2, 2026" },
      { event: "Tutorial Proposal Submission Deadline", date: "March 31, 2026" },
      { event: "Notification of Accepted Proposals", date: "April 15, 2026" },
      { event: "Registration for Tutorials Attendees", date: "June 20 - July 22, 2026" },
    ]
  },
  {
    category: "Call for Abstracts",
    dates: [
      { event: "Abstract Submission Starts", date: "March 2, 2026" },
      {
        event: "Abstract Submission Deadline",
        oldDate: "March 31, 2026",
        newDate: "April 07, 2026",
        newDate1: "April 15, 2026"
      },
      { event: "Notification to Selected Candidates", date: "June 23, 2026" },
      { event: "Actual Event Date", date: "July 22 – 24, 2026" },
      { event: "Registration for Student Research Symposium", date: "July 01 - July 15, 2026" },
    ]
  }
];

function ImportantDatesSection() {
  return (
    <section id="important-dates" className="important-dates section-padding bg-light">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-11">

            {/* Title */}
            <div className="section-title-header text-center mb-5">
              <h2
                className="section-title wow fadeInDown"
                data-wow-delay="0.2s"
                style={{
                  fontSize: '36px',
                  fontWeight: '700',
                  color: '#111'
                }}
              >
                Important Dates
              </h2>
              <div style={{
                width: '80px',
                height: '4px',
                background: '#70b60a',
                margin: '15px auto'
              }} />
            </div>

            {/* Categories */}
            {dateCategories.map((cat) => (
              <div key={cat.category} className="mb-5 wow fadeInUp" data-wow-delay="0.3s">

                <h3 style={{
                  color: '#70b60a',
                  fontSize: '24px',
                  fontWeight: '600',
                  borderLeft: '5px solid #70b60a',
                  paddingLeft: '15px'
                }}>
                  {cat.category}
                </h3>

                <div className="table-responsive" style={{
                  boxShadow: '0 5px 15px rgba(0,0,0,0.05)',
                  borderRadius: '8px',
                  overflow: 'hidden'
                }}>
                  <table className="table table-hover mb-0" style={{ backgroundColor: '#fff' }}>

                    <thead style={{ backgroundColor: '#f8f9fa' }}>
                      <tr>
                        <th scope="col" style={{ padding: '15px' }}>Event</th>
                        <th scope="col" style={{ padding: '15px' }}>Date</th>
                      </tr>
                    </thead>

                    <tbody>
                      {cat.dates.map((item) => (
                        <tr
                          key={item.event}
                          style={{
                            backgroundColor: item.oldDate ? '#fff3f3' : 'transparent',
                            transition: '0.2s'
                          }}
                        >
                          <td style={{ padding: '12px 15px' }}>
                            {item.event}
                          </td>

                          <td style={{
                            padding: '12px 15px',
                            fontWeight: '500'
                          }}>
                            {item.oldDate ? (
                              <>
                                {/* Old Date */}
                                <span style={{
                                  textDecoration: 'line-through',
                                  marginRight: '8px',
                                  color: '#777'
                                }}>
                                  {item.oldDate}
                                </span>

                                {/* If newDate1 exists → strike newDate also */}
                                {item.newDate2 ? (
                                  <>
                                    <span style={{
                                      textDecoration: 'line-through',
                                      marginRight: '8px',
                                      color: '#999'
                                    }}>
                                      {item.newDate}
                                    </span>

                                    <span style={{
                                      textDecoration: 'line-through',
                                      marginRight: '8px',
                                      color: '#999'
                                    }}>
                                      {item.newDate1}
                                    </span>

                                    <strong style={{ color: 'red' }}>
                                      {item.newDate2}
                                    </strong>
                                  </>
                                ) : (
                                  <strong style={{ color: 'red' }}>
                                    {item.newDate}
                                  </strong>
                                )}
                              </>
                            ) : (
                              item.date
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>

                  </table>
                </div>
              </div>
            ))}

          </div>
        </div>
      </div>
    </section>
  );
}

export default ImportantDatesSection;